import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Field, IStateNode, IStateTransition } from '../Models';
import { IRule } from '../../../../Models/tenant';
import { TenantService } from '../../../../Services/tenant.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { ModuleRuleComponent } from './module.rule.component';

@Component({
    selector: "my-modules-transition",
    templateUrl: "./module.transition.component.html",
    styleUrls: ["./module.component.css"],
    imports: [MatButton, MatIcon, MatFormField, MatInput, FormsModule, MatCheckbox, MatIconButton, ModuleRuleComponent]
})
export class ModuleTransitionComponent implements OnInit {
    @Input() moduleId: string;
    @Input() stateNodes: IStateNode[];
    @Input() stateNodeFromId: number;
    @Input() transition: IStateTransition;
    @Input() stateRules: IRule[];
    @Input() stateRulesToSave: number[];
    @Input() conditionFields: Field[];
    @Input() listItemsCache: any[];

    blockUi = false;
    showTransition: boolean;

    constructor(
        private tenantService: TenantService,
        public dialog: MatDialog
    ) {
    }

    ngOnInit(): void {
    }

    getRulesForTransition(): IRule[] {
        return this.stateRules.filter((r) => this.transition.PreConditionRules.indexOf(r.Id) !== -1);
    }

    getPostConditionValueKeysForTransition(): string[] {
        return Object.keys(this.transition.PostConditionValues).filter((k) => k !== "TransitionReason");
    }

    onAddRuleButtonClick() {
        this.createRuleForTransition();
    }

    async createRuleForTransition(rule: IRule = null): Promise<any> {
        let newRule: IRule;

        if (rule) {
            newRule = JSON.parse(JSON.stringify(rule));
            const preConditionRuleToRemove = this.transition.PreConditionRules.indexOf(rule.Id);
            this.transition.PreConditionRules.splice(preConditionRuleToRemove, 1);
        } else {
            newRule = {
                Id: null,
                Description: "",
                OperationType: "StateTransition",
                Conditions: [],
                InstructionType: 0,
                Instructions: null,
                IsActive: true,
                IsValid: true
            };
        }

        newRule.Id = await this.tenantService.getNextRuleId();

        this.stateRules.push(newRule);
        this.stateRulesToSave.push(newRule.Id);
        this.transition.PreConditionRules.push(newRule.Id);
    }

    onDeleteTransitionButtonClick() {
        this.deleteTransition();
    }

    onAddPostConditionValueButtonClick() {
        this.addPostConditionValue();
    }

    onDeletePostConditionValueButtonClick(postConditionValue: string) {
        this.deletePostConditionValue(postConditionValue);
    }

    addPostConditionValue() {
        const regex = /^[a-zA-Z0-9]+$/;

        const newPostConditionValueName = prompt("Enter the name of the new Post Condition Value", "");

        if (newPostConditionValueName === null) {
            return;
        } else if (newPostConditionValueName === "") {
            alert("Name of the new Post Condition Value must be entered");
        } else if (!regex.test(newPostConditionValueName)) {
            alert("Name of the new Post Condition Value must consist only of alphanumeric characters");
        } else {
            this.transition.PostConditionValues[newPostConditionValueName] = "";
        }
    }

    deletePostConditionValue(postConditionValue: string) {
        delete this.transition.PostConditionValues[postConditionValue];
    }

    deleteTransition() {
        const stateNode = this.stateNodes.filter((s) => s.ModuleStatus.Id === this.stateNodeFromId)[0];
        stateNode.StateTransitions = stateNode.StateTransitions.filter((t) => t !== this.transition);
    }

    prettifyLabel(lbl: string): string {
        let op: string;
        if (!lbl) {
            console.log("label undefined");
            return "";
        }
        if (lbl.indexOf(":") > -1) {
            op = lbl.split(":")[1];
        } else {
            op = lbl;
        }

        return op.replace(/_/g, " ");
    }
}